import { useEffect, useRef } from "react";

const SORO_SRC =
  "https://app.trysoro.com/api/embed/d9d54187-d332-4d9e-aae0-f82df92130fe?theme=dark";

export default function SoroBlog() {
  const mountedRef = useRef(false);

  useEffect(() => {
    // Avoid double-loading the script (React StrictMode mounts twice in dev)
    if (mountedRef.current) return;
    mountedRef.current = true;

    const existing = document.querySelector(`script[data-soro="true"]`);
    if (existing) return;

    const script = document.createElement("script");
    script.src = SORO_SRC;
    script.defer = true;
    script.dataset.soro = "true";
    document.body.appendChild(script);
  }, []);

  return (
    <div className="min-h-[60vh] bg-[#050505] text-white">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-16 lg:py-24">
        <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-6">
          <span className="w-8 h-px bg-[#E60000]" />
          Blog · Field notes
        </div>
        <h1 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-7xl tracking-tight leading-[1.0] mb-10">
          From the road.
        </h1>
        <p className="text-zinc-400 text-base lg:text-lg max-w-2xl mb-12">
          Recoveries, transport runs, prestige collections — stories and
          updates straight from the MHJ team.
        </p>
        {/* Soro embed mounts here */}
        <div id="soro-blog" data-testid="soro-blog-embed" />
      </div>
    </div>
  );
}
